import { connect } from 'react-redux';
import { newWarningNotification } from '../../common/redux/actions/notificationActions';
import component from './component';

export default connect(null, { newWarning: newWarningNotification })(component);
